import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { isStaticAsset } from './static-asset.util';

/**
 * Gestion d'erreur transverse : laisse volontairement passer les 401 (gérés en amont par
 * authInterceptor pour le refresh+rejeu) ; force la déconnexion sur 403 ; trace le reste.
 */
export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  // Un fichier statique (locale, image) ne porte pas de session : sortir avant d'injecter
  // AuthService, dont la construction déclencherait une requête qui repasserait ici (NG0200)
  if (isStaticAsset(req.url)) return next(req);

  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          return throwError(() => error);
        }
        if (error.status === 403) {
          auth.logout();
          return throwError(() => error);
        }
        console.error(`[HTTP] ${req.method} ${error.url ?? req.urlWithParams} -> ${error.status}`);
      }
      return throwError(() => error);
    }),
  );
}
